import axios from 'axios';

/**
 * Resolves the API base URL: strips quotes from env, ensures trailing slash,
 * and falls back to local auth API in development so requests never go to the wrong origin.
 */
function getApiBaseUrl(): string {
  const raw =
    process.env.REACT_APP_AUTHENTICATION_API ?? 'https://localhost:8444';
  const trimmed = String(raw).replace(/^["']|["']$/g, '').trim();
  return trimmed.endsWith('/') ? trimmed : `${trimmed}/`;
}

// Authenticated API Client: Token required
export const queueApiClient = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 100000,
});

// Request interceptor for queueApiClient
queueApiClient.interceptors.request.use(config => {
  const updatedConfig = { ...config };
  const token = localStorage.getItem('auth_token');
  const auditLogsAPI = localStorage.getItem('auditLogsApi');

  // Only override baseURL with stored API when it's a valid absolute URL (e.g. after login).
  // Before login, company search and auth must use REACT_APP_AUTHENTICATION_API.
  const isAbsoluteUrl =
    auditLogsAPI &&
    (auditLogsAPI.startsWith('http://') || auditLogsAPI.startsWith('https://'));
  if (isAbsoluteUrl) {
    const base = auditLogsAPI.endsWith('/') ? auditLogsAPI : `${auditLogsAPI}/`;
    updatedConfig.baseURL = base;
  }

  if (token) {
    updatedConfig.headers.Authorization = `Bearer ${token}`;
  }
  return updatedConfig;
}, Promise.reject);

// queueApiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.log("Error received:", error.code, error.message, error.response);
//     // If there is no response (network error, server down) or server error (5xx)
//     if (
//       !error.response ||
//       (error.response.status >= 500 && error.response.status < 600)
//     ) {
//       // Prevent infinite redirect loop
//       if (window.location.pathname !== "/error") {
//         window.location.replace("/error");
//       }
//     }
//     return Promise.reject(error);
//   }
// );
const { get, post, put, patch, delete: destroy } = queueApiClient;
export { get, post, put, patch, destroy };
